export const PublicServerKey = (() => {
    const getaesKey = () => localStorage.getItem('aesKey');
    const setaesKey = (key) => localStorage.setItem('aesKey', key);

    const getaesIV = () => localStorage.getItem('aesIV');
    const setaesIV = (iv) => localStorage.setItem('aesIV', iv);

    return {
        getaesKey: getaesKey,
        setaesKey: setaesKey,
        getaesIV: getaesIV,
        setaesIV: setaesIV,
    }
})();

export const StudentProfile = (() => {
    const getStudentId = () => localStorage.getItem('studentId');
    const getAuthKey = () => localStorage.getItem('authKey');

    const getRewardPoint = () => localStorage.getItem('studentRewardPoint');
    const setRewardPoint = (studentRewardPoint) => localStorage.setItem('studentRewardPoint', studentRewardPoint);

    const getSoundMute = () => localStorage.getItem('isSoundMute');
    const setSoundMute = (isMute) => localStorage.setItem('isSoundMute', isMute);

    const getIsVerify = () => localStorage.getItem('isVerify');
    const setIsVerify = (isVerify) => localStorage.setItem('isVerify', isVerify);

    return {
        getRewardPoint: getRewardPoint,
        setRewardPoint: setRewardPoint,
        getStudentId: getStudentId,
        getAuthKey: getAuthKey,
        getSoundMute: getSoundMute,
        setSoundMute: setSoundMute,
        getIsVerify: getIsVerify,
        setIsVerify: setIsVerify
    }
})();

export const AssementData = (() => {
    const getAssementTitle = () => localStorage.getItem('assementTitle');
    const setAssementTitle = (assementTitle) => localStorage.setItem('assementTitle', assementTitle);

    const getAssementTraitGroupId = () => localStorage.getItem('assementTraitGroupId');
    const setAssementTraitGroupId = (assementTraitGroupId) => localStorage.setItem('assementTraitGroupId', assementTraitGroupId);

    const getHasIncompleteHistory = () => localStorage.getItem('hasIncompleteHistory');
    const setHasIncompleteHistory = (hasIncompleteHistory) => localStorage.setItem('hasIncompleteHistory', hasIncompleteHistory);

    const getAssementRewardPoint = () => localStorage.getItem('assementRewardPoint');
    const setAssementRewardPoint = (assementRewardPoint) => localStorage.setItem('assementRewardPoint', assementRewardPoint);

    const getAssementTypeId = () => localStorage.getItem('assessmentTypeId');
    const setAssementTypeId = (assessmentTypeId) => localStorage.setItem('assessmentTypeId', assessmentTypeId);

    const getAssementTypeName = () => localStorage.getItem('assessmentTypeName');
    const setAssementTypeName = (assessmentTypeName) => localStorage.setItem('assessmentTypeName', assessmentTypeName);

    return {
        getAssementTitle: getAssementTitle,
        setAssementTitle: setAssementTitle,
        getAssementTraitGroupId: getAssementTraitGroupId,
        setAssementTraitGroupId: setAssementTraitGroupId,
        getHasIncompleteHistory: getHasIncompleteHistory,
        setHasIncompleteHistory: setHasIncompleteHistory,
        getAssementRewardPoint: getAssementRewardPoint,
        setAssementRewardPoint: setAssementRewardPoint,
        getAssementTypeId: getAssementTypeId,
        setAssementTypeId: setAssementTypeId,
        getAssementTypeName: getAssementTypeName,
        setAssementTypeName: setAssementTypeName
    }
})();

export const SurveyData = (() => {
    const getSurveyGroupId = () => localStorage.getItem('surveyGroupId');
    const setSurveyGroupId = (surveyGroupId) => localStorage.setItem('surveyGroupId', surveyGroupId);

    const getGroupCompletionBonusPoint = () => localStorage.getItem('groupCompletionBonusPoint');
    const setGroupCompletionBonusPoint = (groupCompletionBonusPoint) => localStorage.setItem('groupCompletionBonusPoint', groupCompletionBonusPoint);

    const getSurveyName = () => localStorage.getItem('surveyName');
    const setSurveyName = (surveyName) => localStorage.setItem('surveyName', surveyName);

    const getMilestoneRewardPoint = () => localStorage.getItem('milestoneRewardPoint');
    const setMilestoneRewardPoint = (milestoneRewardPoint) => localStorage.setItem('milestoneRewardPoint', milestoneRewardPoint);

    const removeSurveyData = () => {
        localStorage.removeItem('surveyGroupId');
        localStorage.removeItem('groupCompletionBonusPoint');
        localStorage.removeItem('surveyName');
        localStorage.removeItem('milestoneRewardPoint');
    }

    return {
        getSurveyGroupId: getSurveyGroupId,
        setSurveyGroupId: setSurveyGroupId,
        getGroupCompletionBonusPoint: getGroupCompletionBonusPoint,
        setGroupCompletionBonusPoint: setGroupCompletionBonusPoint,
        getSurveyName: getSurveyName,
        setSurveyName: setSurveyName,
        getMilestoneRewardPoint: getMilestoneRewardPoint,
        setMilestoneRewardPoint: setMilestoneRewardPoint,
        removeSurveyData: removeSurveyData
    }
})();

export const SnapShotSurveyData = (() => {
    const getSnapshotSurveyId = () => localStorage.getItem('snapshotSurveyId');
    const setSnapshotSurveyId = (snapshotSurveyId) => localStorage.setItem('snapshotSurveyId', snapshotSurveyId);

    const getSnapshotSurveyName = () => localStorage.getItem('snapshotSurveyName');
    const setSnapshotSurveyName = (snapshotSurveyName) => localStorage.setItem('snapshotSurveyName', snapshotSurveyName);

    const getSnapshotRewardPoint = () => localStorage.getItem('snapshotRewardPoint');
    const setSnapshotRewardPoint = (snapshotRewardPoint) => localStorage.setItem('snapshotRewardPoint', snapshotRewardPoint);

    const getSurveySectionCompletedCount = () => localStorage.getItem('surveySectionCompletedCount');
    const setSurveySectionCompletedCount = (surveySectionCompletedCount) => localStorage.setItem('surveySectionCompletedCount', surveySectionCompletedCount);

    const getSurveySectionCount = () => localStorage.getItem('surveySectionCount');
    const setSurveySectionCount = (surveySectionCount) => localStorage.setItem('surveySectionCount', surveySectionCount);

    const getSurveyProcessBar = () => localStorage.getItem('surveyProcessBar');
    const setSurveyProcessBar = (surveyProcessBar) => localStorage.setItem('surveyProcessBar', surveyProcessBar);

    const removeSnapShotSurveyData = () => {
        localStorage.removeItem('snapshotSurveyId');
        localStorage.removeItem('snapshotSurveyName');
        localStorage.removeItem('snapshotRewardPoint');
    }

    return {
        getSnapshotSurveyId: getSnapshotSurveyId,
        setSnapshotSurveyId: setSnapshotSurveyId,
        getSnapshotSurveyName: getSnapshotSurveyName,
        setSnapshotSurveyName: setSnapshotSurveyName,
        getSnapshotRewardPoint: getSnapshotRewardPoint,
        setSnapshotRewardPoint: setSnapshotRewardPoint,
        getSurveySectionCompletedCount: getSurveySectionCompletedCount,
        setSurveySectionCompletedCount: setSurveySectionCompletedCount,
        getSurveySectionCount: getSurveySectionCount,
        setSurveySectionCount: setSurveySectionCount,
        removeSnapShotSurveyData, removeSnapShotSurveyData,
        getSurveyProcessBar: getSurveyProcessBar,
        setSurveyProcessBar: setSurveyProcessBar,
    }
})();

export const Claims = (() => {
    const getToken = () => localStorage.getItem('JwtToken');
    const setToken = (key) => localStorage.setItem('JwtToken', key);

    const getGivenName = () => localStorage.getItem('givenName');
    const setGivenName = (key) => localStorage.setItem('givenName', key);

    const getUniqueName = () => localStorage.getItem('uniqueName');
    const setUniqueName = (key) => localStorage.setItem('uniqueName', key);

    const getJti = () => localStorage.getItem('jti');
    const setJti = (key) => localStorage.setItem('jti', key);

    return {
        getGivenName: getGivenName,
        setGivenName: setGivenName,
        getJti: getJti,
        setJti: setJti,
        getToken: getToken,
        setToken: setToken,
        getUniqueName: getUniqueName,
        setUniqueName: setUniqueName
    }
})();

export const News = (() => {
    const getNewsId = () => localStorage.getItem('newsId');
    const setNewsId = (key) => localStorage.setItem('newsId', key);

    return {
        getNewsId: getNewsId,
        setNewsId: setNewsId
    }
})();